module.exports = __webpack_public_path__ + "static/media/student discipline report.7c37f17a.svg";